import React from 'react';
import styled from 'styled-components';

import { Section, SectionHeader, SectionTitle } from '../styles/Variables';

const SectionBody = styled.div`
	justify-content: space-evenly;
	flex-direction: row;
	font-family: 'Open Sans', sans serif;
	flex-wrap: wrap;
	display: flex;
	padding: 0;
	width: 100%;
`;

const HabilityContainer = styled.div`
	max-width: 600px;
	margin: 2rem 0;
`;

const HabilityHeader = styled.div`
	font-weight: bold;
	font-size: 24px;
	color: #fff;
`;

const HabilityItemContainer = styled.div`
	justify-content: flex-start;
	flex-wrap: wrap;
	display: inline-flex;
	margin: 1rem 1rem; 
`;

const HabilityItem = styled.label`
	background-color: #fff;
	font-weight: bold;
	font-size: 18px;
	padding: 0.25rem 0.5rem;
	margin: 0.5rem;
	color: #8000ff;
`;

export class Habilities extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			habilities: [
				{ title: 'Desenvolvimento Frontend', itens: ['HTML','CSS','BEM','REACT','VUE','SASS','ES6+','CSS-IN-JS'] },
				{ title: 'Desenvolvimento Backend', itens: ['FLASK','EXPRESS','RAILS','GRAILS','API'] },
				{ title: 'Algumas linguagens que gosto', itens: ['JAVASCRIPT','PYTHON','RUBY','RUST','GO','C'] },
				{ title: 'Ferramentas e metodologias que curto', itens: ['GIT','YARN','SCRUM','KANBAM','TDD','FIGMA','TRELLO','ADOBE SUIT','LIBREOFFICE'] },
			]
		};
	}
	render () {
		return (
			<Section background="#8000ff" id="habilities">
				<SectionHeader>
					<SectionTitle color="#fff">As minhas habilidades</SectionTitle>
					<SectionBody>
						{this.state.habilities.map(hability => {
							return  <HabilityContainer>
										<HabilityHeader>{hability.title}</HabilityHeader>
										<HabilityItemContainer>
											{hability.itens.map(item => {
												return <HabilityItem>{item}</HabilityItem>
											})}
											</HabilityItemContainer>
									</HabilityContainer>
						})}
					</SectionBody>
				</SectionHeader>

			</Section>
		);
	}
}